import { render, staticRenderFns } from "./UserCvDownload.vue?vue&type=template&id=4b7a961b&scoped=true&"
import script from "./UserCvDownload.vue?vue&type=script&lang=js&"
export * from "./UserCvDownload.vue?vue&type=script&lang=js&"
import style0 from "./UserCvDownload.vue?vue&type=style&index=0&id=4b7a961b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a961b",
  null
  
)

export default component.exports